/**
 * Refine-AuthProvider als duenne Bruecke zu Stack Auth.
 * Die eigentlichen Auth-Flows (Sign-in/up) rendert <StackHandler> unter /handler/*.
 */
import type { AuthProvider } from "@refinedev/core";
import { stackApp } from "../stack";

export const authProvider: AuthProvider = {
  check: async () => {
    const user = await stackApp.getUser();
    return user
      ? { authenticated: true }
      : { authenticated: false, redirectTo: "/login" };
  },

  login: async () => {
    // Login-UI liegt in der Stack-Auth-Handler-Seite.
    return { success: true, redirectTo: "/login" };
  },

  logout: async () => {
    const user = await stackApp.getUser();
    if (user) await user.signOut();
    return { success: true, redirectTo: "/login" };
  },

  onError: async (error) => {
    const status = (error as { statusCode?: number })?.statusCode;
    if (status === 401 || status === 403) {
      return { redirectTo: "/login", logout: status === 401, error };
    }
    return {};
  },

  getIdentity: async () => {
    const user = await stackApp.getUser();
    if (!user) return null;
    return {
      id: user.id,
      name: user.displayName ?? user.primaryEmail ?? user.id,
      email: user.primaryEmail ?? undefined,
    };
  },
};
